import type { HelpFile } from '../../types/help'
import { ResultTableTestIds } from '../../../testids/ResultTableTestIds'

export const resultTableHelp: HelpFile = {
  docPage: '/docs/reporting/results',
  texts: {
    [ResultTableTestIds.resultTable]:
      'Tabular results returned by the report query.',
    [ResultTableTestIds.btnExportCsv]:
      'Download the current result set as a CSV file.',
    [ResultTableTestIds.btnExportXlsx]:
      'Download the current result set as an Excel (XLSX) file.',
  },
}
